import CircularProgress from "@mui/material/CircularProgress";

const Loader = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100%",
      minHeight: "100px"
    }}
  >
    <CircularProgress />
  </div>
);

export default Loader;
